<template>
  <div>
    <vs-icon v-if="$session.get('role') == 'admin'" @click="openPopup" class="btn-icon" icon="settings"></vs-icon>
    <vs-popup
      class="holamundo"
      title="Schedule Setting"
      background-color-popup="var(--background-color-sidebar)"
      :active.sync="popupActivo"
    >
      <div v-if="numDevice != null">
        <div class="add-schedule" v-for="(item, i) in numDevice.light" :key="i">
          <div class="head">
            <h3>Light F.{{ item.slice(6) }}</h3>
            <PopupAddSchedule
              :device_id="item"
              :floor="floor"
              :index="i - 1"
              v-on:close-popup="closePopup"
            />
          </div>
          <CardSchedule
            :schedule="schedule_light[i]"
            v-on:close-popup="closePopup"
          />
        </div>
        <div class="add-schedule" v-for="(item, i) in numDevice.breaker" :key="i">
          <div class="head">
            <h3>Breaker F.{{ item.slice(8) }} {{item}}</h3>
            <PopupAddSchedule
              :device_id="item"
              :floor="floor"
              :index="i - 1"
              v-on:close-popup="closePopup"
            />
          </div>
          <CardSchedule
            :schedule="schedule_breaker[i]"
            v-on:close-popup="closePopup"
          />
        </div>
        <div class="add-schedule" v-for="(item, i) in numDevice.air" :key="i">
          <div class="head">
            <h3>Air Condition {{ i + 1 }}</h3>
            <PopupAddSchedule
              device="air"
              :device_id="item"
              :floor="floor"
              :index="i - 1"
              v-on:close-popup="closePopup"
            />
          </div>
          <CardSchedule
            :schedule="schedule_air[i]"
            device="air"
            v-on:close-popup="closePopup"
          />
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import CardSchedule from "./CardSchedule.vue";

import PopupAddSchedule from "./PopupAddSchedule.vue";

export default {
  props: {
    numDevice: {
      type: Object,
      default: null,
    },
    schedule_light: {
      type: [Array, Object],
      default: [],
    },
    schedule_breaker: {
      type: [Array, Object],
      default: [],
    },
    schedule_air: {
      type: [Array, Object],
      default: [],
    },
    floor: { type: Number, default: undefined },
  },
  components: {
    PopupAddSchedule,
    CardSchedule,
  },
  data() {
    return {
      popupActivo: false,
    };
  },
  mounted() {
    console.log(this.schedule_Air, this.schedule_light);
  },
  methods: {
    closePopup(value) {
      this.popupActivo = value;
    },
    openPopup() {
      if (this.$session.get("role") == "admin") {
        this.$store.dispatch("i_APC/genData");
      this.$store.dispatch("i_APC/getSchedule");
      this.popupActivo = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-icon {
  cursor: pointer;
}
.add-schedule {
  display: flex;
  flex-direction: column;
  .head {
    margin: 10px 0 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h3 {
      font-weight: bold;
    }
  }
}
.holamundo {
  border-radius: 50px;
}
</style>